<template>
  <!-- 推荐列表 -->
  <div class="list-block">
    <div class="block-flex">
      <div class="flex-txt" :class="itemIndex === 0 ? 'cur' : ''" @click="handleClickItems(0, '1')"
        v-track="{ functionName: '猜你喜欢' }">猜你喜欢</div>
      <div class="flex-txt" :class="itemIndex === 1 ? 'cur' : ''" @click="handleClickItems(1, '2')"
        v-track="{ functionName: '热门精选' }">热门精选</div>
      <div class="flex-txt" :class="itemIndex === 2 ? 'cur' : ''" @click="handleClickItems(2, '3')"
        v-track="{ functionName: '最新上架' }">最新上架</div>
    </div>
    <div class="tips-title" :class="userInfo.recommendTips + '' === '1' ? 'hidd' : ''">
      「长按内容」,可反馈您对推荐内容的意见哦!
      <img src="../../../assets/images/home/icon@2x.png" @click="handleCloseTitleTips" class="close-img" alt="">
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" id="list-block" @load="onLoad" class="list">
      <div v-for="(item, index) in list" :key="index" v-longpress="() => handleLongPress(item, index)" class="longpress"
        :class="item.isShowFeedback ? 'show-feedback' : ''">
        <div class="item-video" v-if="item.fileId && item.type === 2">
          <div class="item-txt" @click.stop="handleDialogUnlock(item, index)">{{ item && item.title }}</div>
          <!-- <video :src="item.videoUrl" class="video-block" controls :poster="item.coverUrl"></video> -->
          <div class="video-block" v-if="!item.isPlayVideo" @click.stop="handleDialogUnlock(item, index, 'videoPlay')">
            <div :style="`background-image: url(${item.coverUrl});`" class="video-block" alt=""></div>
            <img src="@/assets/images/course/icon-play-course.png" class="icon-play" alt="">
          </div>
          <VideoPlayerAnswer v-else ref="video" @handlePlay="handlePlay" :playerVideo="item"></VideoPlayerAnswer>
          <div class="info-txt2" v-if="item.type === 2">
            <span>讲师：{{ item && item.keynoteSpeaker }}</span>
            <span class="txt2">
              <img src="@/assets/images/home/search_view@2x.png" class="eyes" alt="">
              {{ item.readNum > 0 ? item.readNum : 0 }}
            </span>
          </div>
          <div class="info-txt2" v-if="itemIndex === 2">上架时间：{{ item && item.times }}</div>
          <div class="item-unlock" v-if="`${item.isUnlock}` === '1' && !item.myUnlock">
            <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
            <span class="txt">{{ item && item.unlockCost }}积分解锁</span>
          </div>
        </div>
        <div class="item" v-else @click.stop="handleDialogUnlock(item, index)">
          <div class="item-info">
            <div class="info-txt1">{{ item && item.title }}</div>
            <div class="info-txt2" v-if="item.type === 2">
              <span>讲师：{{ item && item.keynoteSpeaker }}</span>
              <span class="txt2">
                <img src="@/assets/images/home/search_view@2x.png" class="eyes" alt="">
                {{ item.readNum > 0 ? item.readNum : 0 }}
              </span>
            </div>
            <div class="info-txt2" v-if="item.type === 3">
              <span>作者：{{ item && item.keynoteSpeaker }}</span>
              <span class="txt2">
                <img src="@/assets/images/home/search_view@2x.png" class="eyes" alt="">
                {{ item.readNum > 0 ? item.readNum : 0 }}
              </span>
            </div>
            <div class="info-txt2" v-if="item.type === 1">
              <span v-if="itemIndex === 2">上架时间：{{ item && item.times }}</span>
              <span v-else></span>
              <span class="txt2">
                <img src="@/assets/images/home/search_view@2x.png" class="eyes" alt="">
                {{ item.readNum > 0 ? item.readNum : 0 }}
              </span>
            </div>
            <div class="info-txt2" v-else-if="itemIndex === 2">上架时间：{{ item && item.times }}</div>
            <div class="item-unlock" v-if="`${item.isUnlock}` === '1' && !item.myUnlock">
              <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
              <span class="txt">可使用{{ item && item.unlockCost }}积分兑换</span>
            </div>
          </div>
          <div class="item-cover" :style="`background-image: url(${item.coverUrl});`"></div>
        </div>
        <div class="wrapp-con" v-if="item && item.isShowFeedback">
          <div class="wrapp-bg"></div>
          <div class="wrapps">
            <img src="../../../assets/images/common/icon-close-btn.png" @click="handleClose" class="img-close" alt="">
            <div class="top-txt">
              该内容对您当前技能提升是否有帮助?
            </div>
            <div class="top-btn">
              <div class="btn-left" @click="handleFeedBack(index, true)">
                <img src="../../../assets/images/home/icon_like@2x.png" class="img-icon" alt="">
                <div class="btn-txt">是</div>
              </div>
              <div class="btn-left" @click="handleFeedBack(index, false)">
                <img src="../../../assets/images/home/icon_like@2x2.png" class="img-icon" alt="">
                <div class="btn-txt">否</div>
              </div>
              <div class="btn-txt2" @click="isFeedBack = true;">反馈</div>
            </div>
          </div>
        </div>
      </div>
    </van-list>

    <van-overlay :show="isFeedBack" @click="isFeedBack = false">
      <div class="wrap" @click.stop>
        <div class="wrap-txt">反馈</div>
        <div class="wrap-con">
          <van-field v-model="feedModel" rows="2" autosize type="textarea" maxlength="200"
            placeholder="请输入您的反馈，以便我们更好的为您推荐学习内容" show-word-limit />
        </div>
        <div class="warp-btn">
          <div class="btn btn1" @click="isFeedBack = false">取消</div>
          <div class="btn btn2" @click="handleFeedBack(feedBackIndex, 'feedback')">提交反馈</div>
        </div>
      </div>
    </van-overlay>
    <dialogUnlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialogUnlock>
  </div>
</template>
<script>
import {
  homeRecommend,
  homeHot,
  homeNewest,
  sendFeedback,
  recommendTips
} from '../../../api/api'
import { setSha, traceClickURL } from '../../../utils/util'
import VideoPlayerAnswer from './VideoPlayerAnswer.vue'
import dialogUnlock from '@/components/dialogUnlock.vue'
import {isScorm} from '../../../api/scorm'
export default {
  components: {
    VideoPlayerAnswer,
    dialogUnlock
  },
  data () {
    return {
      itemIndex: 0,
      pageNum: 1,
      pageSize: 5,
      list: [],
      load: false,
      finished: false,
      loading: false,
      isFeedBack: false,
      feedModel: '',
      feedBackIndex: 0,
      dataDetails: {},
      curIndex: 0,
      typeTxt: '',
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  mounted () {
    window.sessionStorage.setItem('entrance', '1')
    this.userInfo.recommendTips = localStorage.getItem('recommendTips') ? localStorage.getItem('recommendTips') : this.userInfo.recommendTips
  },
  methods: {
    // 关闭长按提示框
    handleCloseTitleTips () {
      recommendTips({
        userId: this.userInfo.id
      }).then(() => {
        this.userInfo.recommendTips = '1'
        localStorage.setItem('recommendTips', 1)
      })
    },
    // 关闭反馈弹窗
    handleClose () {
      this.list = this.list.map(res => {
        res.isShowFeedback = false
        return res
      })
    },
    // 反馈操作
    handleFeedBack (index, type) {
      this.feedBackIndex = index
      this.list = this.list.map(res => {
        res.isShowFeedback = false
        return res
      })
      // type、反馈类型1系统反馈意见2推荐反馈意见3每日答题反馈意见
      // baseId 业务id，
      // baseType 业务类型 1文献2课程3病例
      // baseTitle 业务标题（文献、课程、病例标题）
      let content = ''
      if (type === 'feedback') {
        content = this.feedModel
      } else {
        content = type ? '是' : '否'
      }
      let params = {
        type: 2,
        baseId: this.list[index].baseId,
        baseType: this.list[index].type,
        baseTitle: this.list[index].title,
        title: '意见反馈',
        content,
        state: 2,
        userName: this.userInfo.realName,
        userId: this.userInfo.id,
        role: this.userInfo.roles[0],
        phone: this.userInfo.phone,
        email: this.userInfo.email,
        openId: this.userInfo.iepOpenId
      }
      sendFeedback(params).then(res => {
        if (res.code === 0) {
          this.feedModel = ''
          this.isFeedBack = false
          this.$toast('反馈成功，将为您优化推荐结果')
          if (!type) {
            this.list.splice(index, 1)
          }
        } else {
          this.$toast(res.msg)
        }
      })
    },

    // 长按显示框框
    handleLongPress (item, index) {
      if (this.itemIndex !== 0) return
      this.handleCloseTitleTips()
      this.list = this.list.map(res => {
        res.isShowFeedback = false
        return res
      })
      this.list[index].isShowFeedback = true
    },

    onLoad () {
      if (this.load) {
        return
      }
      this.load = true
      if (this.itemIndex === 0) {
        homeRecommend({
          'pageNum': this.pageNum,
          'pageSize': this.pageSize,
          'openId': this.userInfo.iepOpenId,
          'positionTitle': this.userInfo.positionTitle
        }).then(res => {
          this.load = false
          if (res.data.list.length < this.pageSize) {
            this.finished = true
          }
          res.data.list = res.data.list.map(item => {
            item.isPlayVideo = false
            item.coverUrl = encodeURI(item.coverUrl)
            return item
          })
          this.list = this.list.concat(res.data.list)
          // 加载状态结束
          this.loading = false
          this.pageNum++
        })
      } else if (this.itemIndex === 1) {
        homeHot({
          'pageNum': this.pageNum,
          'pageSize': this.pageSize
        }).then(res => {
          this.load = false
          if (res.data.list.length < this.pageSize) {
            this.finished = true
          }
          res.data.list = res.data.list.map(item => {
            item.isPlayVideo = false
            item.coverUrl = encodeURI(item.coverUrl)
            return item
          })
          this.list = this.list.concat(res.data.list)
          // 加载状态结束
          this.loading = false
          this.pageNum++
        })
      } else if (this.itemIndex === 2) {
        homeNewest({
          'pageNum': this.pageNum,
          'pageSize': this.pageSize
        }).then(res => {
          this.load = false
          res.data.list.map(item => {
            item.isPlayVideo = false
            item.times = this.$moment(item.createTime * 1).format('YYYY-MM-DD HH:mm')
            item.coverUrl = encodeURI(item.coverUrl)
            return item
          })
          if (res.data.list.length < this.pageSize) {
            this.finished = true
          }
          this.list = this.list.concat(res.data.list)
          // 加载状态结束
          this.loading = false
          this.pageNum++
        })
      }
    },
    // 点击分类
    handleClickItems (index, itemTxt) {
      let listBlock = document.getElementById('list-block')
      console.log(listBlock.offsetHeight)
      listBlock.style.minHeight = listBlock.offsetHeight + 'px'
      this.itemIndex = index
      window.sessionStorage.setItem('entrance', itemTxt)
      this.pageNum = 1
      this.finished = false
      this.list = []
      this.onLoad()
    },

    handlePlay (e) {
      let videos = this.$refs.video
      for (let i in videos) {
        if (videos[i].playerVideo.id !== e.id) {
          videos[i].player.pause()
        }
      }
    },

    handlePlayVideo () {
      let index = this.curIndex
      let item = this.dataDetails
      this.list[index].isPlayVideo = !item.isPlayVideo
      setTimeout(() => {
        let videos = this.$refs.video
        for (let i in videos) {
          if (videos[i].playerVideo.id === item.id) {
            videos[i].player.play()
          }
        }
      })
    },

    handleDialogUnlock (item, index, type) {
      this.curIndex = index
      this.dataDetails = item
      this.typeTxt = type
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      if (type === 'videoPlay') {
        this.handlePlayVideo()
      } else {
        this.handleJump()
      }
    },

    async handleJump () {
      if (this.typeTxt === 'videoPlay') {
        this.handleClickItems(this.itemIndex, Number(this.itemIndex) + 1)
        this.handlePlayVideo()
        return
      }
      let item = this.dataDetails
      // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=${window.sessionStorage.getItem('entrance')}&businessChannel=${window.sessionStorage.getItem('entrance')}`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            entrance: window.sessionStorage.getItem('entrance'),
            channel: window.sessionStorage.getItem('entrance')
          }
        })
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.baseId}${openid}${iepTxt}${trackParams}`
      } else if (item.type === 3) {
        setTimeout(() => { traceClickURL() })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        const query = {
          courseId: item.baseId,
          sectionId: item.sectionId,
          entrance: window.sessionStorage.getItem('entrance'),
          channel: window.sessionStorage.getItem('entrance')
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    }
  }
}
</script>
<style lang="less" scoped>
* {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.list-block {
  padding: 0 16px;
  box-sizing: border-box;
  width: 100%;

  .block-flex {
    display: flex;
    align-items: center;
    position: sticky;
    left: 0;
    top: 0;
    width: 100%;
    height: 50px;
    background: #fff;
    z-index: 99;
    justify-content: space-between;
    padding: 0 20px;
    box-sizing: border-box;
    z-index: 998;

    .flex-txt {
      font-size: 16px;
      color: #6A7481;
      line-height: 26px;

      &.cur {
        font-weight: 600;
        color: #000000;
        position: relative;

        &::after {
          position: absolute;
          bottom: -4px;
          left: 50%;
          transform: translateX(-50%);
          content: '';
          width: 16px;
          height: 4px;
          background-color: #EB1700;
          border-radius: 100px;
        }
      }
    }
  }

  .list {
    .item-unlock {
      display: flex;
      align-items: center;
      height: 20px;
      margin-top: 2px;

      .icon-unlock {
        width: 10px;
        margin-right: 4px;
        display: block;
      }

      .txt {
        color: #EB1700;
        font-size: 12px;
      }
    }
    .item {
      display: flex;
      margin-bottom: 16px;
      justify-content: space-between;

      .item-info {
        display: flex;
        flex-direction: column;
        margin-right: 26px;
        flex: 1;

        .info-txt1 {
          font-size: 14px;
          color: #000000;
          font-weight: 500;
          line-height: 20px;
          height: 40px;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          -webkit-line-clamp: 2;
        }

        .info-txt2 {
          color: #B1B1B1;
          font-size: 13px;
          line-height: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;

          .txt2 {
            display: flex;
            align-items: center;
            font-size: 12px;
            color: #B1B1B1;
            line-height: 20px;

            .eyes {
              width: 18px;
              display: block;
              margin-right: 3px;
            }
          }
        }
      }

      .item-cover {
        width: 110px;
        min-width: 110px;
        max-width: 110px;
        height: 60px;
        display: block;
        object-fit: cover;
        background-repeat: no-repeat;
        background-size: cover;
      }

    }

    .item-video {
      margin-bottom: 16px;

      .item-txt {
        color: #000000;
        font-size: 14px;
        line-height: 20px;
        font-weight: 500;
        margin-bottom: 10px;
      }

      .video-block {
        display: block;
        width: 100%;
        height: 200px;
        object-fit: cover;
        position: relative;
        background-repeat: no-repeat;
        background-size: cover;

        .icon-play {
          position: absolute;
          width: 40px;
          display: block;
          left: 50%;
          top: 50%;
          transform: translateX(-50%) translateY(-50%);
        }
      }

      .info-txt2 {
        color: #B1B1B1;
        font-size: 13px;
        line-height: 20px;
        margin-top: 4px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .txt2 {
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #B1B1B1;
          line-height: 20px;

          .eyes {
            width: 18px;
            display: block;
            margin-right: 3px;
          }
        }
      }
    }

    .show-feedback {
      position: relative;

      .wrapp-con {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 4px;
        overflow: hidden;

        .wrapp-bg {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          left: 0;
          z-index: 99;
          border-radius: 4px;
          background: rgba(86, 76, 71, 0.9);
        }

        .wrapps {
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          height: 100%;
          z-index: 999;

          .img-close {
            width: 14px;
            right: 13px;
            box-sizing: border-box;
            display: block;
            position: absolute;
            top: 8px;
          }

          .top-txt {
            font-size: 13px;
            color: #FFFFFF;
            line-height: 20px;
            margin-bottom: 8px;
            padding-left: 13px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          .top-btn {
            display: flex;
            align-items: center;
            padding-left: 13px;
            box-sizing: border-box;

            .btn-left {
              width: 128px;
              margin-right: 16px;
              border-radius: 4px;
              background: rgba(255, 255, 255, 0.45);
              display: flex;
              align-items: center;
              justify-content: center;

              .img-icon {
                width: 16px;
                height: 16px;
                display: block;
                margin-right: 4px;
              }

              .btn-txt {
                font-size: 14px;
                color: #FFFFFF;
              }
            }

            .btn-txt2 {
              font-size: 13px;
              color: #FFFFFF;
            }
          }
        }
      }
    }
  }
}

.tips-title {
  background-image: url('../../../assets/images/home/bg_frame@2x.png');
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 34px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  color: #000;
  padding: 0 13px;
  padding-top: 8px;
  box-sizing: border-box;
  transition: all .3s;

  &.hidd {
    height: 0;
    padding: 0;
    margin-bottom: 0;
    opacity: 0;
  }

  .close-img {
    display: block;
    width: 12px;
    height: 12px;
  }
}

/deep/ .van-overlay {
  z-index: 9999;

  .wrap {
    width: 320px;
    border-radius: 10px;
    background: #fff;
    padding: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;

    .img-wrap {
      width: 80px;
      display: block;
      margin-bottom: 18px;
      margin-left: 50%;
      transform: translateX(-50%);
    }

    .wrap-txt {
      font-size: 17px;
      line-height: 24px;
      font-weight: 600;
      color: #000000;
      margin-bottom: 15px;
      text-align: center;

      &.wrap-txt2 {
        border-bottom: 1px solid #A9AEB6;
        padding-bottom: 10px;
        box-sizing: border-box;
        text-align: left;
        margin-bottom: 14px;
      }
    }

    .wrap-con {
      border: 1px solid rgba(0, 0, 0, 0.07);
      border-radius: 30px;
      background: rgba(0, 0, 0, 0.02);
      font-size: 14px;
      color: #333;

      .van-cell {
        background: rgba(0, 0, 0, 0.02);
      }
    }

    .wrap-txt3 {
      position: relative;

      &::before {
        content: '*';
        font-size: 17px;
        color: #FF0000;
        width: 9px;
        text-align: center;
        display: inline-block;
      }
    }

    .wrap-con {
      width: 288px;
      margin-left: 50%;
      transform: translateX(-50%);
      color: #666;
      font-size: 16px;
      margin-bottom: 20px;

      .href-txt {
        color: #EB1700;
      }
    }

    .warp-btn {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 8px;
      height: 55px;
      box-sizing: border-box;

      .btn {
        text-align: center;
        font-size: 17px;
        font-weight: 500;
        border-radius: 30pc;
        height: 42px;
        line-height: 42px;

        &.btn1 {
          color: #81766F;
          background: #F1EFED;
        }

        &.btn2 {
          background: #EB1700;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/components/recommend.vue